import React, { useState } from 'react'
import RootAdmin from '../../../../components/layouts/RootAdmin'
import { Button, Card, CardBody, CardHeader, TableCell, TableRow } from '@nextui-org/react'
import HeaderPage from '../../../../components/elements/HeaderPage'
import useSWR from 'swr';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { deleteFetcher, getFetcher } from '../../../../services/api';
import { month } from '../../../../services/enum';
import ClientTablePagination from '../../../../components/elements/ClientTablePagination';
import ModalAlert from '../../../../components/elements/ModalAlert';
import { ArrowLeftIcon, PencilSquareIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import useCustomNavigate from '../../../../hooks/useCustomNavigate';
import ModalDetailPengangkutan from '../../../../components/fragments/admin/report/transport/ModalDetailPengangkutan';

export default function VehicleDetailPage() {
    const {id} = useParams();
    const navigate = useNavigate()
    const { createReportTransportVehicle, editReportTransportVehicle } = useCustomNavigate()
    const {data, isLoading, mutate } = useSWR(`/api/pelaporan-pengangkutan/find/${id}`, getFetcher)
    const [deleteId, setDeleteId] = useState(null)
    const [isOpenModalDeleteAlert, setIsOpenModalDeleteAlert] = useState(false)

    const handleOpenModalDeleteAlert = (detailId) => {
        setDeleteId(detailId)
        setIsOpenModalDeleteAlert(true)
    }

    const handleDelete = async (detailId) => {
        try {
            await deleteFetcher(`/api/pelaporan-pengangkutan/delete/pengakutan-detail`, detailId);
            toast.success("Data pengangkutan berhasil dihapus!");
            mutate();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Gagal menghapus data pengangkutan.");
        } finally {
            setIsOpenModalDeleteAlert(false);
            setDeleteId(null);
        }
    }

    const header = [
        'Jenis B3', 
        'Total Pengangkutan', 
        'Perusahaan Asal Muat',
        'Perusahaan Tujuan Bongkar',
        'Aksi'
    ]
    

    const content = (item) => (
        <TableRow key={item?.id}>
            <TableCell>
                <strong>{item?.dataBahanB3?.casNumber}</strong> / {item?.dataBahanB3?.namaBahanKimia}
            </TableCell>
            <TableCell>
                {item?.jumlahB3} Kg
            </TableCell>
            <TableCell>
                {[...new Set(item?.DataPerusahaanTujuanBongkarOnPengakutanDetail?.map((detail) => detail.perusahaanAsalMuat?.id))].map((asalMuatId, index) => {
                    const asalMuatDetail = item?.DataPerusahaanTujuanBongkarOnPengakutanDetail.find((detail) => detail.perusahaanAsalMuat?.id === asalMuatId);
                    if (!asalMuatDetail) return null;
                    return (<div key={`asal-${index}`}>{asalMuatDetail?.perusahaanAsalMuat?.namaPerusahaan || "N/A"}</div>);
                })}
            </TableCell>
            <TableCell>
                {[...new Set(item?.DataPerusahaanTujuanBongkarOnPengakutanDetail?.map((detail) => detail.perusahaanTujuanBongkar?.id))].map((tujuanBongkarId, index) => {
                    const tujuanBongkarDetail = item?.DataPerusahaanTujuanBongkarOnPengakutanDetail.find((detail) => detail.perusahaanTujuanBongkar?.id === tujuanBongkarId);
                    if (!tujuanBongkarDetail) return null;
                    return (<div key={`tujuan-${index}`}>{tujuanBongkarDetail?.perusahaanTujuanBongkar?.namaPerusahaan || "N/A"}</div>);
                })}

            </TableCell>
            <TableCell>
                <div className="flex gap-1">
                    <ModalDetailPengangkutan data={item} />
                    <Button onPress={() => editReportTransportVehicle(id, item?.id)} isIconOnly size="sm" color="warning">
                        <PencilSquareIcon className="size-4" />
                    </Button>
                    <Button onPress={() => handleOpenModalDeleteAlert(item?.id)} isIconOnly size="sm" color="danger" aria-label="Hapus data pengangkutan">
                        <TrashIcon className="size-4" />
                    </Button>
                </div>
            </TableCell>
        </TableRow>
    )

    return (
        <RootAdmin>
            <HeaderPage title={`${data?.vehicle?.modelKendaraan} / ${data?.vehicle?.noPolisi}`} subtitle={"Detail Riwayat Pengangkutan Kendaraan"}  />
            <div className='grid grid-cols-1 md:grid-cols-4 gap-3 mt-3'>
                <Card radius='sm' className="col-span-1">
                    <CardBody className='flex flex-col gap-3'>
                        <div className={`flex flex-col`}>
                            <span className='text-xs text-ink-400 uppercase'>Periode</span>
                            <span className='text-sm font-medium'>{data?.period?.name}</span>
                        </div>
                        <div className={`flex flex-col`}>
                            <span className='text-xs text-ink-400 uppercase'>Bulan</span>
                            <span className='text-sm font-medium'>{month[data?.bulan-1]}</span>
                        </div>
                        <div className={`flex flex-col`}>
                            <span className='text-xs text-ink-400 uppercase'>Tahun</span>
                            <span className='text-sm font-medium'>{data?.tahun}</span>
                        </div>
                    </CardBody>
                </Card>
                <Card radius='sm' className='col-span-3'>
                    <CardHeader className='w-full flex gap-1'>
                        <Button startContent={<ArrowLeftIcon className='size-4'/>} onPress={() => navigate(-1)} size='sm' color='warning' variant='flat'>Kembali</Button>
                        <Button onPress={() => createReportTransportVehicle(id)} size='sm' color='primary' startContent={<PlusIcon className='size-4'/>}>Tambah</Button>
                    </CardHeader>
                    <CardBody>
                        <ClientTablePagination
                            data={data?.pengangkutanDetails}
                            isLoading={isLoading}
                            header={header}
                            content={content}
                        />
                    </CardBody>
                </Card>
            </div>
            <ModalAlert
                heading="Apakah Anda Yakin Menghapus Data Pengangkutan Ini?"
                buttonSubmitText="Ya"
                icon="danger"
                onSubmit={() => handleDelete(deleteId)}
                isOpen={isOpenModalDeleteAlert}
                onOpenChange={setIsOpenModalDeleteAlert}
            />
        </RootAdmin>
    )
}